export enum ERestaurantImageType {
  REFRIGERATOR = 'refrigerator',
  TEMP_PANEL = 'temp-panel',
  RESTAURANT_EXTERIOR = 'restaurant-exterior',
  RESTAURANT_INTERIOR = 'restaurant-interior',
  GLASSWARE = 'glassware',
  DRINK_MENU_SAMPLE = 'drink-menu-sample',
}
